import Marquee from "react-fast-marquee";

const ITEMS = [
  "HVAC", "Plumbing", "Electrical", "Appliance Repair", "Garage Doors",
  "Niagara Falls", "St. Catharines", "Welland", "Thorold", "Niagara-on-the-Lake",
  "Fort Erie", "Port Colborne", "Grimsby", "Beamsville", "Hamilton",
];

export const TradeMarquee = () => (
  <div className="border-y-2 border-asphalt bg-safety py-3 sm:py-4" data-testid="marquee-strip">
    <Marquee speed={35} gradient={false} pauseOnHover aria-hidden="true">
      {ITEMS.map((item) => (
        <span
          key={item}
          className="mx-6 font-display text-xl font-bold uppercase tracking-wide text-asphalt sm:text-2xl"
        >
          {item} <span className="ml-6 font-mono">//</span>
        </span>
      ))}
    </Marquee>
  </div>
);
